// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/pipes/index-of/index-of.pipe";
import * as i4 from "SecurityListsApp/ts/features/security-list-selector-modals/components/multi-select-list/pipes/is-multi-select-list-item-selected.pipe";
import * as i5 from "SecurityListsApp/ts/features/security-list-selector-modals/components/multi-select-list/pipes/is-multi-select-sub-list-item-selected.pipe";
const _c0 = (a0, a1) => ({ open: a0, selected: a1 });
function MultiSelectListComponent_div_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiSelectListComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function MultiSelectListComponent_div_1_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); const item_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectItem(item_r2)); });
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "span", 6);
    i0.ɵɵtemplate(3, MultiSelectListComponent_div_1_div_1_div_3_Template, 3, 1, "div", 7);
    i0.ɵɵpipe(4, "isMultiSelectListItemSelected");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", item_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(4, 2, item_r2, ctx_r2.selectedItems, ctx_r2.activeSecurityGroupTab));
} }
function MultiSelectListComponent_div_1_div_2_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiSelectListComponent_div_1_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 12);
    i0.ɵɵlistener("click", function MultiSelectListComponent_div_1_div_2_div_8_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r5); const item_r2 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectItem(item_r2)); });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Select All");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MultiSelectListComponent_div_1_div_2_div_8_div_4_Template, 3, 1, "div", 7);
    i0.ɵɵpipe(5, "isMultiSelectListItemSelected");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(5, 1, item_r2, ctx_r2.selectedItems, ctx_r2.activeSecurityGroupTab));
} }
function MultiSelectListComponent_div_1_div_2_div_9_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiSelectListComponent_div_1_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 12);
    i0.ɵɵlistener("click", function MultiSelectListComponent_div_1_div_2_div_9_Template_div_click_1_listener() { const subItem_r7 = i0.ɵɵrestoreView(_r6).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.selectItem(subItem_r7)); });
    i0.ɵɵelement(2, "span", 14);
    i0.ɵɵtemplate(3, MultiSelectListComponent_div_1_div_2_div_9_div_3_Template, 3, 1, "div", 7);
    i0.ɵɵpipe(4, "isMultiSelectListItemSelected");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subItem_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", subItem_r7.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(4, 2, subItem_r7, ctx_r2.selectedItems, ctx_r2.activeSecurityGroupTab));
} }
function MultiSelectListComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵpipe(1, "indexOf");
    i0.ɵɵpipe(2, "isMultiSelectSubListItemSelected");
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵlistener("click", function MultiSelectListComponent_div_1_div_2_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r4); const item_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openItem(item_r2)); });
    i0.ɵɵelement(4, "div", 13)(5, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵpipe(7, "indexOf");
    i0.ɵɵtemplate(8, MultiSelectListComponent_div_1_div_2_div_8_Template, 6, 5, "div", 16)(9, MultiSelectListComponent_div_1_div_2_div_9_Template, 5, 6, "div", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c0, i0.ɵɵpipeBind2(1, 5, ctx_r2.openListItems, item_r2) > -1, i0.ɵɵpipeBind3(2, 8, item_r2, ctx_r2.selectedItems, ctx_r2.activeSecurityGroupTab)));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("textContent", item_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !(i0.ɵɵpipeBind2(7, 12, ctx_r2.openListItems, item_r2) > -1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r2.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r2.sub_list);
} }
function MultiSelectListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MultiSelectListComponent_div_1_div_1_Template, 5, 6, "div", 2)(2, MultiSelectListComponent_div_1_div_2_Template, 10, 18, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r2.sub_list);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.sub_list);
} }
/**
 * Multi Select List Component
 *
 * Displays lists and sub lists for each security list category in the multi security list selector modal, and allows you to
 * select multiple security lists.
 *
 * Input Properties:
 *  activeSecurityGroupTab: SecurityGroupName that is the group name for the current active tab in the multi security list selector modal.
 *  listItems: SecurityListCategoryListItem[] to display.
 *  selectedItems: MultiSelectSecurityListItem[] that contains the currently selected security lists and their security groups.
 *
 * Output Properties:
 *  selectItemHandler: emits the list item that was clicked
 */
export class MultiSelectListComponent {
    constructor() {
        this.selectItemHandler = new EventEmitter();
        this.openListItems = [];
    }
    isOpen(item) {
        return this.openListItems.indexOf(item) > -1;
    }
    openItem(item) {
        if (this.isOpen(item)) {
            // If the item is already open, then close it by removing it from the list of open items
            this.openListItems = this.openListItems.filter((openItem) => openItem.key !== item.key);
        }
        else {
            this.openListItems.push(item);
            // Get new object reference to make pure pipes run again
            this.openListItems = this.openListItems.slice();
        }
    }
    selectItem(item) {
        this.selectItemHandler.emit({ item, group: this.activeSecurityGroupTab });
    }
}
MultiSelectListComponent.ɵfac = function MultiSelectListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiSelectListComponent)(); };
MultiSelectListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiSelectListComponent, selectors: [["ycn-multi-select-list"]], inputs: { activeSecurityGroupTab: "activeSecurityGroupTab", listItems: "listItems", selectedItems: "selectedItems" }, outputs: { selectItemHandler: "selectItemHandler" }, standalone: false, decls: 2, vars: 1, consts: [[1, "linked-list-body", "linked-list-sublist"], [4, "ngFor", "ngForOf"], ["class", "linked-list-item parent", 3, "click", 4, "ngIf"], ["class", "linked-list-item linked-list-item-dropdown", 3, "ngClass", 4, "ngIf"], [1, "linked-list-item", "parent", 3, "click"], [1, "linked-list-item-header"], [1, "text-gray-10", 3, "textContent"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], ["ycnIcon", "", 3, "name"], [1, "linked-list-item", "linked-list-item-dropdown", 3, "ngClass"], [1, "linked-list-item-header", 3, "click"], [1, "btn", "dropdown-toggler"], [3, "textContent"], [1, "linked-list-item-body", 3, "hidden"], ["class", "linked-list-item", 4, "ngIf"], ["class", "linked-list-item", 4, "ngFor", "ngForOf"], [1, "linked-list-item"]], template: function MultiSelectListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MultiSelectListComponent_div_1_Template, 3, 2, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.listItems);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.IconDirective, i3.IndexOfPipe, i4.isMultiSelectListItemSelectedPipe, i5.isMultiSelectSubListItemSelectedPipe], encapsulation: 2 });
